import { ReactElement } from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

type TypeProps = {
  title: string;
  icon: ReactElement;
  placement?: TooltipProps['placement'];
};

export const Badge = ({ title, icon, placement = 'top' }: TypeProps) => {
  return (
    <Tooltip title={title} placement={placement} arrow>
      {icon}
    </Tooltip>
  );
};
